package com.iregained.site.components.sections.home.styles

import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.boxShadow
import com.varabyte.kobweb.compose.ui.modifiers.scale
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.selectors.hover
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.rgba
import org.jetbrains.compose.web.css.s

val ProductImageStyle = CssStyle {
    base {
        Modifier.borderRadius(16.px).boxShadow(0.px, 10.px, 30.px, color = rgba(0, 0, 0, 0.08f))
            .transition(Transition.of("transform", 0.4.s))
    }
    hover {
        Modifier.scale(1.02)
    }
}